import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { messages } from './messages';

Vue.use(VueI18n);

export const SUPPORTED_LOCALES = Object.freeze(['zh-CN', 'zh-TW', 'en-US']);

function normalizeLocale(locale) {
  const normalized = String(locale || '').replace('_', '-');
  if (/^en(?:-|$)/i.test(normalized)) {
    return 'en-US';
  }
  if (/^zh-(?:TW|HK|MO|Hant)(?:-|$)/i.test(normalized)) {
    return 'zh-TW';
  }
  if (/^zh(?:-|$)/i.test(normalized)) {
    return 'zh-CN';
  }
  return '';
}

export function getClientLocales() {
  return Array.isArray(navigator.languages) && navigator.languages.length
    ? navigator.languages
    : [navigator.language];
}

export function resolveClientLocale(clientLocales = getClientLocales()) {
  for (const clientLocale of clientLocales) {
    const supportedLocale = normalizeLocale(clientLocale);
    if (supportedLocale) {
      return supportedLocale;
    }
  }
  return 'zh-CN';
}

export function resolveClientRegion(clientLocale = getClientLocales()[0]) {
  const normalized = String(clientLocale || '').replace('_', '-');
  const region = normalized
    .split('-')
    .slice(1)
    .find(subtag => /^[a-z]{2}$/i.test(subtag));
  if (region) {
    return region.toUpperCase();
  }
  return /^zh(?:-Hans)?$/i.test(normalized) ? 'CN' : '';
}

export const i18n = new VueI18n({
  locale: resolveClientLocale(),
  fallbackLocale: false,
  messages,
  silentTranslationWarn: process.env.NODE_ENV === 'production',
  missing(locale, key) {
    throw new Error(`Missing i18n message: locale=${locale}, key=${key}`);
  }
});

export function getCurrentLocale() {
  return i18n.locale;
}

export function setLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) {
    throw new Error(`Unsupported locale: ${locale}`);
  }
  i18n.locale = locale;
  document.documentElement.setAttribute('lang', locale);
  document.title = i18n.t('app.title');
}

export function syncLocaleWithClient() {
  setLocale(resolveClientLocale());
}

document.documentElement.setAttribute('lang', i18n.locale);
window.addEventListener('languagechange', syncLocaleWithClient);
